// removed by extract-text-webpack-plugin
module.exports = {"footer":"styles__footer___1raMh","rotate":"styles__rotate___1Hn_3","fadein":"styles__fadein___c5C1i","slideFromRight":"styles__slideFromRight___4V7pw","waves":"styles__waves___1aXW_"};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/Footer/styles.scss
// module id = ./resources/assets/js/components/Footer/styles.scss
// module chunks = 0